<template>
    <div class="ds-accordion-item" :class="{ 'is-open': defaultOpen }" @click="handleToggle">
        <button
            type="button"
            class="ds-accordion-item__header"
            aria-expanded="false"
            :id="`ds-accordion-item-${itemId}`"
            :aria-controls="`ds-accordion-item-content-${itemId}`"
        >
            <slot name="summary"></slot>
            <DsIcon
                :width="24"
                :height="24"
                :name="headerIconName"
                :is-in-storybook="isInStorybook"
                class="ds-accordion-item__header-icon"
            />
        </button>
        <div
            :id="`ds-accordion-item-content-${itemId}`"
            class="ds-accordion-item__body"
            role="region"
            :aria-labelledby="`ds-accordion-item-${itemId}`"
        >
            <hr class="ds-accordion-item__body-divider" />
            <div class="ds-accordion-item__body-content">
                <slot name="text"></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import DsIcon from "../icon/ds-icon.vue";
import type { SvgIcons } from "../icon/types";
import { ref } from "vue";

const props = withDefaults(
    defineProps<{
        /**
         * If open by default
         */
        defaultOpen?: boolean;
        /**
         * Set item id for accessibility
         */
        itemId?: number;
        /**
         * Set header icon name
         */
        headerIconName?: SvgIcons;
        /**
         * Show in Storybook
         */
        isInStorybook?: boolean;
    }>(),
    {
        itemId: 0,
        headerIconName: "arrow-down",
    }
);

const isOpen = ref(props.defaultOpen);
const emit = defineEmits(["expanded"]);

const handleToggle = () => {
    isOpen.value = !isOpen.value;
    if (isOpen.value) emit("expanded");
};
</script>
